// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_DadosBancariosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /implantacao/dados_bancarios — o franqueado grava a conta da própria franquia (rascunho aceito). */
import { registerContract } from './validate'

export interface Implantacao_DadosBancariosInput {
franquia_id?: number
banco?: string
agencia?: string
conta?: string
tipo_conta?: string
titular?: string
documento_titular?: string
pix?: string
}

registerContract('Implantacao_DadosBancariosInput', {
  franquia_id:       { type: 'number',  required: false },
  banco:             { type: 'string',  required: false },
  agencia:           { type: 'string',  required: false },
  conta:             { type: 'string',  required: false },
  tipo_conta:        { type: 'string',  required: false },
  titular:           { type: 'string',  required: false },
  documento_titular: { type: 'string',  required: false },
  pix:               { type: 'string',  required: false },
})
